import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {FormFieldProps} from '../../../../common/types/components';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import WorkDataSectionView from '../../../components/views/mx/turboCash/WorkDataSectionView';

const mapStateToProps = (state, {match, showErrors}) => {
    const employment = state.turboCash.loanApplication.applicantEmployment;
    const employmentDataViewFieldErrorState = state.turboCash.ui.workDataStepView.fieldErrors;
    const {countrySelector, catalogs} = state;

    return {
        catalogs,
        showErrors,
        colonies: employment.colonies,
        employmentRotation: catalogs.employmentRotation,
        workplaceNameField: new FormFieldProps(
            employment.workplaceName, employmentDataViewFieldErrorState.workplaceNameFieldError),
        positionField: new FormFieldProps(
            employment.position, employmentDataViewFieldErrorState.positionFieldError),
        workingSinceField: new FormFieldProps(
            employment.workingSince, employmentDataViewFieldErrorState.workingSinceFieldError),
        employmentRotationField: new FormFieldProps(
            employment.employmentRotation, employmentDataViewFieldErrorState.employmentRotationFieldError),
        addressField: new FormFieldProps(
            employment.address, employmentDataViewFieldErrorState.addressFieldError),
        extNumberField: new FormFieldProps(
            employment.extNumber, employmentDataViewFieldErrorState.extNumberFieldError),
        intNumberField: new FormFieldProps(
            employment.intNumber, employmentDataViewFieldErrorState.intNumberFieldError),
        streetBetweenField: new FormFieldProps(
            employment.streetBetween, employmentDataViewFieldErrorState.streetBetweenFieldError),
        workplacePhoneField: new FormFieldProps(
            employment.workplacePhone, employmentDataViewFieldErrorState.workplacePhoneFieldError),
        workplacePhoneExtField: new FormFieldProps(
            employment.workplacePhoneExt, employmentDataViewFieldErrorState.workplacePhoneExtError),
        monthlyIncomesField: new FormFieldProps(
            employment.monthlyIncomes, employmentDataViewFieldErrorState.monthlyIncomesFieldError),
        postalCodeField: new FormFieldProps(
            employment.postalCode, employmentDataViewFieldErrorState.postalCodeFieldError),
        stateField: new FormFieldProps(
            WizardValidationUtils.getCatalogValue(employment.state), employmentDataViewFieldErrorState.stateFieldError),
        cityField: new FormFieldProps(
            WizardValidationUtils.getCatalogValue(employment.city), employmentDataViewFieldErrorState.cityFieldError),
        municipalityField: new FormFieldProps(
            WizardValidationUtils.getCatalogValue(employment.municipality),
            employmentDataViewFieldErrorState.municipalityFieldError),
        colonyField: new FormFieldProps(
            employment.selectedColony, employmentDataViewFieldErrorState.selectedColonyFieldError),
        countrySelected: countrySelector.countrySelected,
        loanApplicationToken: match.params.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeWorkplaceName: (workplaceName, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_TC_ACTION.action(workplaceName, error));
        },
        onChangePosition: (position, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_POSITION_TC_ACTION.action(position, error));
        },
        onChangeWorkingSince: (workingSince, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_TC_ACTION.action(workingSince, error));
        },
        onChangeEmploymentRotation: (employmentRotation, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_ROTATION_ACTION.action(employmentRotation, error));
        },
        onChangeAddress: (address, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_ADDRESS_TC_ACTION.action(address, error));
        },
        onChangeExtNumber: (extNumber, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_TC_ACTION.action(extNumber, error));
        },
        onChangeIntNumber: (intNumber, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_TC_ACTION.action(intNumber, error));
        },
        onChangeStreetBetween: (streetBetween, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_STREET_BETWEEN_ACTION.action(streetBetween, error));
        },
        onChangeWorkplacePhone: (workplacePhone, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_TC_ACTION.action(workplacePhone, error));
        },
        onChangeWorkplacePhoneExt: (workplacePhoneExt, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_TC_ACTION.action(workplacePhoneExt, error));
        },
        onChangeMonthlyIncomes: (monthlyIncomes, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_TC_ACTION.action(monthlyIncomes, error));
        },
        onChangePostalCode: country => (postalCode, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.action(postalCode, country, error));
        },
        onChangeColony: (colony, error) => {
            dispatch(WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_TC_ACTION.action(colony, error));
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    const {countrySelected} = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        onChangePostalCode: dispatchProps.onChangePostalCode(countrySelected)
    };
};

const WorkDataSectionContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(WorkDataSectionView));

export default WorkDataSectionContainer;